module.exports = __webpack_public_path__ + "static/ios15_cover-177c8c1002c949b1120adfaa2abf82fb.png";